import type { FC } from 'react';
import NavIconActions from '@/components/navigation/NavIconActions/NavIconActions.client';
import NavSidebarContent from '@/components/navigation/NavSidebarContent/NavSidebarContent.client';
import Sidebar from '@/components/navigation/Sidebar/Sidebar.client';
import ArrowLink from '@/components/ui/ArrowLink';

const NavActions: FC = () => {
  return (
    <div className='flex items-center gap-x-5'>
      <div className='hidden items-center gap-x-5 lg:flex'>
        <NavIconActions />
        <ArrowLink
          href='https://app.bunkersuite.com'
          target='_blank'
          size='md'
          className='text-base/6'
          aria-label='Log in to Bunker Suite application (opens in new tab)'
        >
          Log in
        </ArrowLink>
      </div>
      <div className='flex lg:hidden'>
        <Sidebar>{(toggle: (value: boolean) => void) => <NavSidebarContent onClose={toggle} />}</Sidebar>
      </div>
    </div>
  );
};

export default NavActions;
